// Audit notes are persisted with whatever area/page key was current at
// creation time (see createAuditNote callers). Renaming those keys from
// Danish to English left existing notes tagged with the old spelling —
// this maps old -> new so historical notes still group/filter correctly
// instead of silently falling into an "other" bucket after the rename.
const LEGACY_PAGE_KEY_MAP = {
  identitet: 'identity',
  enheder: 'devices',
  sikkerhed: 'security',
  applikationer: 'applications',
  roller: 'roles',
  licenser: 'licenses',
  grupper: 'groups',
  databeskyttelse: 'data-protection',
  gaestebrugere: 'guest-users',
  beslutninger: 'decisions',
  historik: 'history',
  arbejdsko: 'work-queue',
};

export function normalizePageKey(page) {
  return LEGACY_PAGE_KEY_MAP[page] || page;
}
